'use strict';
const {sdkTextElement, sdkMessageElement, localizeSdkElement} = require('../i18n/sdk-text');


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ID = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,179}$/;

const unopened = p => p.status === 'SEALED' || p.status === 'REVEALED';

async function findNextUnopened(readPage, currentPackId, {
  isCurrent = () => true,
  maxPages = 200
} = {}) {
  let cursor;
  const cursors = new Set();

  for (let page = 0; page < maxPages; page++) {
    if (!isCurrent()) throw Error('SESSION_CHANGED');
    const result = await readPage(cursor);
    if (!isCurrent()) throw Error('SESSION_CHANGED');
    if (!result || !Array.isArray(result.items) || result.items.length > 50 || !(result.cursor === null || typeof result.cursor === 'string' && result.cursor.length > 0 && result.cursor.length <= 1024) || result.items.some(p => !p || typeof p.packId !== 'string' || !ID.test(p.packId) || !['SEALED', 'REVEALED', 'OPENED'].includes(p.status))) throw Error('INVALID_PACK_LIST');
    const next = result.items.find(p => p.packId !== currentPackId && unopened(p));
    if (next) return next.packId;
    if (result.cursor === null) return null;
    if (cursors.has(result.cursor)) throw Error('REPEATED_PACK_CURSOR');
    cursors.add(result.cursor);
    cursor = result.cursor;
  }

  throw Error('PACK_SCAN_INCOMPLETE');
}

async function confirmedNext(api, currentPackId, {
  isCurrent = () => true
} = {}) {
  for (let attempt = 0; attempt < 3; attempt++) {
    const next = await findNextUnopened(cursor => api.packs(cursor), currentPackId, {
      isCurrent
    });
    if (next === null) return null;
    const pack = await api.pack(next);
    if (!isCurrent()) throw Error('SESSION_CHANGED');
    if (!pack || pack.packId !== next || !['SEALED', 'REVEALED', 'OPENED'].includes(pack.status)) throw Error('INVALID_NEXT_PACK');
    if (unopened(pack)) return next;
  }

  throw Error('NEXT_PACK_CHANGED_RETRY');
}

function createOpeningNavigation(React) {
  var _temp;

  const h = React.createElement;
  return _temp = class OpeningNavigation extends React.Component {
    constructor(props) {
      super(props);

      _defineProperty(this, "refresh", async () => {
        const run = ++this.generation;
        this.setState({
          busy: true,
          known: false,
          error: ''
        });

        try {
          const nextPackId = await findNextUnopened(cursor => this.props.runtime.api.packs(cursor), this.props.currentPackId, {
            isCurrent: () => this.alive && run === this.generation
          });
          if (this.alive && run === this.generation) this.setState({
            known: true,
            nextPackId
          });
        } catch (_error) {
          if (this.alive && run === this.generation) this.setState({
            known: false,
            nextPackId: null,
            error: '未能確認剩餘卡包，請重新查詢。'
          });
        } finally {
          if (this.alive && run === this.generation) this.setState({
            busy: false
          });
        }
      });

      _defineProperty(this, "proceed", async () => {
        if (this.state.busy) return;
        if (!this.state.known) return this.refresh();
        const run = ++this.generation,
              runtime = this.props.runtime;
        this.setState({
          busy: true,
          error: ''
        });

        try {
          const next = await confirmedNext(runtime.api, this.props.currentPackId, {
            isCurrent: () => this.alive && run === this.generation
          });
          if (!this.alive || run !== this.generation) return;
          this.setState({
            known: true,
            nextPackId: next
          });

          if (next === null) {
            if (typeof this.props.onPackages === 'function') this.props.onPackages();
          } else if (runtime.readOnly !== true && runtime.openingEnabled !== false && typeof this.props.onOpenPack === 'function') this.props.onOpenPack(next);
        } catch (_error) {
          if (this.alive && run === this.generation) this.setState({
            known: false,
            nextPackId: null,
            error: '未能確認剩餘卡包，請重新查詢。'
          });
        } finally {
          if (this.alive && run === this.generation) this.setState({
            busy: false
          });
        }
      });

      this.state = {
        busy: true,
        known: false,
        nextPackId: null,
        error: ''
      };
      this.generation = 0;
    }

    componentDidMount() {
      this.alive = true;
      this.refresh();
    }

    componentDidUpdate(prev) {
      if (prev.runtime !== this.props.runtime || prev.currentPackId !== this.props.currentPackId) this.refresh();
    }

    componentWillUnmount() {
      this.alive = false;
      ++this.generation;
    }

    render() {
      const s = this.state,
            r = this.props.runtime,
            closed = r.readOnly === true || r.openingEnabled === false,
            disabled = s.busy || s.known && (s.nextPackId ? closed || typeof this.props.onOpenPack !== 'function' : typeof this.props.onPackages !== 'function');
      return h('div', {
        className: 'opcards-opening-next'
      }, h('button', {
        type: 'button',
        onClick: this.proceed,
        disabled
      }, s.busy ? sdkTextElement('正在查詢卡包…') : !s.known ? sdkTextElement('重新查詢下一張卡') : s.nextPackId ? sdkTextElement('開啟下一張卡') : sdkTextElement('返回卡包')), s.error && h('p', {
        role: 'status'
      }, sdkTextElement(s.error)));
    }

  }, _temp;
}

module.exports = {
  findNextUnopened,
  confirmedNext,
  createOpeningNavigation
};
